import { Grid } from '@mui/material';
import { WsTypography, WsTypoVariants } from 'wisestep-base';

import { currencyNameSymbolMap } from '../../../../utils/CurrencyHelper';
import CountWithTextCard from '../../../analytics/components/countWithTextCard';
import { resolveTimeSpan } from '../../../jobs/listing/components/viewJd/potentialRevenue/PotentialRevenue';
import { PotentialRevenueWidget } from '../../DerivedCharts/helper';
import usePotentialRevenueWidgetData from '../../DerivedCharts/PotentialRevenue/hooks/usePotentialRevenueWidgetData';
import { IPotentialRevenueDTO } from '../jobs/types/postgreJobsDTO';
import { IPotentialRevenueWidgetProp } from '../jobs/types/postgreJobsWidgetProp';

const defaultRevenueMetricData = { USD: 0 } as IPotentialRevenueDTO;

const PotentialRevenueMetricChart = ({ query, title, widgetName }: IPotentialRevenueWidgetProp) => {
  const widgetData = usePotentialRevenueWidgetData<IPotentialRevenueDTO>(
    query,
    defaultRevenueMetricData
  );

  const filteredEntries = Object.entries(widgetData).filter(
    ([currency_timespan, value]) =>
      currency_timespan && currency_timespan.split('_')[0] && value != null && value !== 0
  );
  const timeSpan = widgetName == PotentialRevenueWidget.METRIC_NET_MARGIN_GBP_CONT ? 'day' : '';

  return (
    <Grid container justifyContent="space-around" rowSpacing={2} p={2}>
      <Grid item xs={12}>
        <WsTypography variant={WsTypoVariants.TITLE} bold>
          {title}
        </WsTypography>
      </Grid>
      {filteredEntries.map(([currency_timespan, value]) => {
        const currency = currency_timespan.split('_')[0];
        const _timeSpan = resolveTimeSpan(currency_timespan.split('_')[1] || timeSpan);
        return (
          <Grid key={currency_timespan} item xs="auto">
            <CountWithTextCard
              variant="h4"
              count={`${currencyNameSymbolMap[currency] ?? ''}${Number(
                value.toFixed(0)
              ).toLocaleString()}${_timeSpan ? `/${_timeSpan}` : ''}`}
              fullHeight
              text={currencyNameSymbolMap[currency] ? '' : currency}
              textVariant="caption"
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default PotentialRevenueMetricChart;
